<div class="container">
    <div class="single-column-layout">
        <h1>
            Import
            @if (importType === 'site') {
                <span>Sites</span>
            }
            @if (importType === 'parcel') {
                <span>Parcels</span>
            }
        </h1>

        <div [style.display]="(!isImporting && !userCancelled) ? 'block' : 'none'">
            <div class="mb-3">
                <label>Top Level Company:</label>
                <company-picker class="import-sites-picker"
                                [topLevelOnly]="true"
                                (companySelected)="companySelected($event)">
                </company-picker>
            </div>

            <div class="mb-3">
                <label>Comment:</label>
                <textarea class="form-control" style="width: 50%" rows="5" [(ngModel)]="payload.comment"></textarea>
            </div>

            <div class="mb-3">
                <input #fileInput type='file' (change)="fileChanged($event)" accept=".txt" style="display:inline-block">
                <span (click)="clearFilePicker()">
          @if (hasFile) {
              <i class="fa fa-close"></i>
          }
        </span>
            </div>

            <div class="mt-3">
                <button class="ace-btn btn-secondary"
                        (click)="startImporting(true)"
                        [disabled]="!payload.topCompanyID || !fileLines">
                    Validate
                </button>
                <button class="ace-btn btn-primary ms-2"
                        (click)="startImporting(false)"
                        [disabled]="!payload.topCompanyID || !fileLines">
                    Import
                </button>
            </div>
        </div>

        @if (isImporting) {
            <div class="text-center">
                @if (!userCancelled && initIndex < fileLines.length) {
                    <h3 class="repeating-ellipses text-start">Reading File</h3>
                }
                @if (!userCancelled && initIndex >= fileLines.length) {
                    <h3 class="text-start">Done</h3>
                }
                @if (userCancelled) {
                    <h3>Cancelled</h3>
                }
                <div [style.display]="userCancelled ? 'none' : 'block'">
                    <progressbar class="active"
                                 [class.progress-striped]="initIndex < fileLines.length"
                                 [max]="fileLines.length - 1"
                                 [value]="initIndex - 1"
                                 type="info">
                    </progressbar>
                </div>
                <h3>
                    {{ successfulImportCount }} / {{ fileLines.length - 1 }}
                    @if (importType === 'site') {
                        <span>Sites</span>
                    }
                    @if (importType === 'parcel') {
                        <span>Parcels</span>
                    }
                    Successfully
                    @if (payload.validateOnly) {
                        <span>Validated</span>
                    }
                    @if (!payload.validateOnly) {
                        <span>Imported</span>
                    }
                </h3>
                <div class="mt-3">
                    @if (!userCancelled && !userCancelling && initIndex < fileLines.length) {
                        <button
                            class="ace-btn btn-secondary"
                            (click)="cancelImport()">
                            Cancel
                        </button>
                    }
                    @if (userCancelled || initIndex >= fileLines.length) {
                        <button
                            class="ace-btn btn-primary ms-2"
                            (click)="initValues()">
                            OK
                        </button>
                    }
                </div>
            </div>
        }

        @if (userCancelling) {
            <div class="text-center">
                <h3>Cancelling...</h3>
                <ws-ace-loader [hasOverlay]="false" [marginTop]="50" [marginBottom]="0"></ws-ace-loader>
            </div>
        }
        @if (warnings && warnings.stringArray) {
            <div>
                @if (warnings.stringArray.length > 0) {
                    <h3>
                        Problems encountered during
                        @if (payload.validateOnly) {
                            <span>validation:</span>
                        }
                        @if (!payload.validateOnly) {
                            <span>import:</span>
                        }
                    </h3>
                }
                <display-String-Array-component [data]="warnings"></display-String-Array-component>
            </div>
        }
    </div>
</div>

